import React from "react";
import {Cancel} from "mdi-material-ui";

export default function Reject(props) {
    return (
        <Cancel className={props.className} />
    );
};